import { render, staticRenderFns } from "./ScreenShot.vue?vue&type=template&id=57f59b61&scoped=true&"
import script from "./ScreenShot.vue?vue&type=script&lang=js&"
export * from "./ScreenShot.vue?vue&type=script&lang=js&"
import style0 from "./ScreenShot.vue?vue&type=style&index=0&id=57f59b61&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f59b61",
  null
  
)

export default component.exports